import { FC, ReactNode } from 'react'
import { Flex, GreyGrey30, GreyWhite } from '@sequencehq/core-components'

/**
 * Fixed bottom bar that lays primary CTAs out as equal-width columns: a single
 * action spans the full width, two split it 50/50, etc. Shared by the inbox
 * preview pane (InboxPreview) and the manual-task modal (ManualTaskLayout) so
 * the two mobile surfaces stay in sync.
 *
 * Actions are expected to be simple buttons/links. Both `button` and `a` are
 * stretched (some actions render as links, e.g. "View invoice"), and the
 * selector reaches one level of wrapping so actions grouped in a Flex (the
 * common case) still divide evenly — richer nested controls should not be
 * placed here.
 */
export const MobileActionBar: FC<{
  children: ReactNode
  'data-testid'?: string
}> = ({ children, 'data-testid': dataTestId }) => {
  return (
    <Flex
      gap="8px"
      padding="12px 16px"
      backgroundColor={GreyWhite}
      borderTop={`1px solid ${GreyGrey30}`}
      sx={{
        '& > *': { flex: 1, minWidth: 0 },
        '& > * > button, & > * > a, & > button, & > a': {
          flex: 1,
          width: '100%'
        }
      }}
      data-testid={dataTestId}
    >
      {children}
    </Flex>
  )
}
